import { createVuetify, ThemeDefinition } from 'vuetify'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
//import { VDataTable } from 'vuetify/labs/VDataTable'

/*import { VBtn } from 'vuetify/components/VBtn'
import { VImg } from 'vuetify/components/VImg'
import { VIcon } from 'vuetify/components/VIcon'
//import { VSpacer } from 'vuetify/components/VGrid'
import { VTextField } from 'vuetify/components/VTextField'
import { VFileInput } from 'vuetify/components/VFileInput'
import { Ripple } from 'vuetify/directives'
*/

const myQuoteTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#f27c38',
    'primary-darken-1': '#3700B3',
    secondary: '#03DAC6',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
/*    status1: '#5253FF',
    status2: '#00BFA5',
    status3: '#1DE9B6',
    status4: '#393939',
    status5: "#723813",
    status6: "#F05818",
    status7: "#4dc3be",
    status8: "#4B8380",
    status1variant: '#DCDCFD',
    status9: "#E0E0E0",
    */
    footer: '#393939',
  },
}

export default defineNuxtPlugin(nuxtApp => {
  const vuetify = createVuetify({
    //components: {VBtn, VImg, VIcon, VTextField, VFileInput },
    //directives: {Ripple},
    components,
    directives,
    theme: {
      defaultTheme: 'myQuoteTheme',
      themes: {
        myQuoteTheme,
      },
    },
  })

  nuxtApp.vueApp.use(vuetify)
})
